module.exports = __webpack_public_path__ + "assets/img/klix_carto.wmf.675b6ec2.svg";